import styled from '@xstyled/styled-components'
import { Block } from '../block/block'

export const MoteErrorMessageRoot = styled(Block).attrs({
  spreadX: true,
  spreadY: true,
  align: 'center',
  justify: 'center',
  gap: 12,
  maxWidth: 393,
  minWidth: 204,
  minHeight: 104,
  maxHeight: 208
})(props => ({
  color: props.theme.colors.grey.d2,
  background: props.theme.colors.white,
  borderRadius: props.theme.radii.lg,
  border: `1px solid ${props.theme.colors.grey.l2}`,
  boxSizing: 'border-box'
}))
